import { createContext, useContext } from "react";
import type { IMenuItem } from "./types";

export type MenuContextValue = {
  onSelect: (optionId: string) => void;
  options: IMenuItem[];
  rtl?: boolean;
};

export const MenuContext = createContext<MenuContextValue>(
  {} as MenuContextValue,
);

export const useMenuContext = () => {
  return useContext(MenuContext);
};
